import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { SelectItem } from "primeng/api";
import { TranslateService } from "@ngx-translate/core";
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { Rest } from 'app/rest/rest_client';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { CardConsumptionService } from 'app/modules/vehicle-inventory/services/table-management/cardConsumption.service';

import CardConsumption = Rest.CardConsumption;
import { CardService } from 'app/rest/card.service';
import { RestExt } from 'app/services/rest-client-extension';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { VehicleService } from 'app/rest/vehicle.service';
import { MileageService } from 'app/modules/vehicle-inventory/services/table-management/mileage.service';

@Component({
    selector: 'app-cardConsumption-form',
    templateUrl: './cardConsumption-form.component.html',
    styleUrls: ['./cardConsumption-form.component.scss'],
    providers: [CardConsumptionService, CardService],
    encapsulation: ViewEncapsulation.None,
})
export class CardConsumptionFormComponent
    extends EntityFormComponent<CardConsumption>
    implements OnInit, OnChanges {
    noticeChannels: SelectItem[];
    channelsList: Rest.NoticeChannel[];
    title: string;
    dateConsumption: Date;

    // Preservation of relationships
    cardRequestContext: Rest.ListPaginationRequest;
    vehicleRequestContext: Rest.ListPaginationRequest;
    cardList: Rest.Card[] = [];
    vehicleList: Rest.Vehicle[] = [];

    @Input() card: Rest.Card;
    @Input() vehicle: Rest.Vehicle;
    isCardConsumption: boolean;
    cardPlaceholder: string = '';
    vehiclePlaceholder: string = '';
    editCard: boolean = true;
    consumptionDate: Date;
    editVehicle: boolean = true;
    errorMessages: string[] = [];

    @Output() saveCompleted: EventEmitter<void> = new EventEmitter<void>();

    isCreateGranted: boolean = false;
    isUpdateGranted: boolean = false;
    formManipulation: boolean = false;

    constructor(
        private cardConsumptionService: CardConsumptionService,
        private vehicleService: VehicleService,
        notificationsService: NotificationsService,
        protected i18n: I18nService,
        private authenticationService: AuthenticationService,
        private translate: TranslateService,
        public translateService: TranslateService,
        private cardService: CardService,
        private userTime: UserTimePipe,
        protected mileageService: MileageService
    ) {
        super(cardConsumptionService, notificationsService, i18n, authenticationService);
    }

    ngOnInit() {
        super.ngOnInit();

        this.setPermissions();
    }

    
    ngOnChanges(changes: SimpleChanges) {
        if (changes['isCardConsumption']) {
            if(this.isNew){
                this.title = this.isCardConsumption ? this.translateService.instant('tableManagement.cardsConsumption.createCardConsumption'): 
                this.translateService.instant('tableManagement.cardsConsumption.createManualRefueling');
            }else{
                this.title = this.isCardConsumption ? this.translateService.instant('tableManagement.cardsConsumption.editCardConsumption'):
                this.translateService.instant('tableManagement.cardsConsumption.editManualRefueling');
            }
        }
    }

    setPermissions(){
        const user = this.authenticationService.user;
		
		this.isCreateGranted = this.authenticationService.isRoleGranted('INV_CARD_CONSUMPTION_CREATE', user);
        this.isUpdateGranted = this.authenticationService.isRoleGranted('INV_CARD_CONSUMPTION_UPDATE', user);
    }

    /**
     * Loads and evaluates all the necessary data before showing the form.
     *
     * @memberof CardConsumptionFormComponent
     */
    beforeShow() {
        this.dateConsumption = null;
        this.cardList = [];
        this.cardRequestContext = RestExt.firstPageRequestVehicleInventory();
        this.vehicleRequestContext = RestExt.firstPageRequest();


        if(this.vehicle){
            this.cardRequestContext.filters["vehicle"] = [this.vehicle.name];
            this.vehicleRequestContext.filters["name"] = [this.vehicle.name];
            this.editVehicle = false;
            this.entity.vehicle = this.vehicle;
        }

        if (this.isNew) {
            this.title = this.isCardConsumption ? this.translateService.instant('tableManagement.cardsConsumption.createCardConsumption'): 
            this.translateService.instant('tableManagement.cardsConsumption.createManualRefueling');
        } else {           
            //#region PRESERVATION OF RELATIONSHIPS
            //CARD
            if(this.entity.card){
                this.isCardConsumption = true;
                this.cardRequestContext.filters["number"] = [this.entity.card.number];
            }else{
                this.isCardConsumption = false;
            }

            this.title = this.isCardConsumption ? this.translateService.instant('tableManagement.cardsConsumption.editCardConsumption'):
            this.translateService.instant('tableManagement.cardsConsumption.editManualRefueling');
            //#endregion PRESERVATION OF RELATIONSHIPS

            this.dateConsumption = this.userTime.utcToCalendarDate(
                this.entity.consumptionDate
            );

            
        }

        this.cardService.getPage(this.cardRequestContext).then((p) => {
            this.cardList = p.entities;
        });

        this.vehicleService.getPage(this.vehicleRequestContext).then((p) => {
            this.vehicleList = p.entities;
        });
        this.cardPlaceholder = this.translateService.instant('general.select');
        this.cardPlaceholder += ' ';
        this.cardPlaceholder += this.translateService.instant('tableManagement.cardsConsumption.card');

        this.vehiclePlaceholder = this.translateService.instant('general.select') + ' ' + this.translateService.instant('tableManagement.cardsConsumption.vehicle');

        if (this.card !== null && this.card !== undefined) {
            this.entity.card = this.card;
            this.cardPlaceholder = this.card.number;
            this.editCard = false;
        }
    }

    onChangeCard(event) {
        this.entity.card = event.value;
        this.entity.vehicle = this.entity.card?.vehicle;
        this.vehicleRequestContext = {
            sortBy: "id",
            sortAsc: true,
            pageSize: 10,
            filters:{}
        } as unknown as Rest.ListPaginationRequest;

        
        this.vehicleRequestContext.filters["name"] = [this.vehicle.name];
        

        this.vehicleService.getPage(this.vehicleRequestContext).then((p) => {
            this.vehicleList = p.entities;
        });
    }

    onFilterCard(event) {
        this.cardRequestContext = {
            sortBy: "number",
            sortAsc: true,
            pageSize: 10,
            filter:{}
        } as unknown as Rest.ListPaginationRequest;

        if(this.vehicle){
            this.cardRequestContext.filters["vehicle"] = [this.vehicle.name];
        }
        this.cardRequestContext.filters["number"] = [event.filter];
        this.cardService.getPage(this.cardRequestContext).then((p) => {
            this.cardList = p.entities;
        });
    }

    onChangeVehicle(event) {
        this.entity.vehicle = event.value;
    }

    onFilterVehicle(event) {
        this.vehicleRequestContext = {
            sortBy: "id",
            sortAsc: true,
            pageSize: 10,
            filters:{}
        } as unknown as Rest.ListPaginationRequest;

        
        this.vehicleRequestContext.filters["name"] = [event.filter];
        

        this.vehicleService.getPage(this.vehicleRequestContext).then((p) => {
            this.vehicleList = p.entities;
        });
    }

    onKeyDownDecimal(event: any) {
        var pressedKey = event.key;
        const keyMap = new Map<number, string>();
        keyMap.set(190, ",");
        keyMap.set(110, ",");
        const { keyCode } = event;
        if (!event.target.value.includes(',') && (keyMap.has(keyCode) || pressedKey === ',')) {
            event.preventDefault();
            event.target.value += ',';
        }
    }

    protected beforeSave(): void {
        this.entity.consumptionDate = this.dateConsumption;
        //this.entity.vehicle = this.vehicle;
    }

    protected afterSave(): void {
        if(this.entity.kms !== null && this.entity.kms !== 0){
            this.saveCompleted.emit();
            this.mileageService.refreshGetPage.next(true);
        }    
    }


    validateConsumptionForm() {
        this.errorMessages = [];
    
        if (
          !this.entity.vehicle ||
          !this.entity.consumptionDate ||
          (!this.entity.amount &&
          !this.entity.liters &&
          !this.entity.kms)
        ) {

          if(!this.entity.vehicle || ! this.entity.consumptionDate){
            this.notificationsService.add(Severity.error,this.translateService.instant('error.required-field.generic'),"");
          }else {
            this.notificationsService.add(Severity.error,this.translateService.instant('error.required-field.consumption'),"");
          }
          
          window.scroll({ top: 0, behavior: 'smooth' });
        }
        return this.errorMessages.length === 0;
      }

    saveChanges() {
        var that = this;
        this.beforeSave();

        if (this.validateConsumptionForm()) {
    
            if (this.isNew) {
                //console.log(this.file);   
                this.cardConsumptionService.create(this.entity).then((p) => {
                    that.display = false;
                    that.isNew = false;
                    that.entity = p;
                    that.afterSave();
                    that.return.emit(p);
                });
            } else {
                this.cardConsumptionService.update(this.entity).then((p) => {
                    that.display = false;
                    that.afterSave();
                    that.return.emit(p);                    
                });
            }

            
      }

      
    }
    show(isCardConsumption: boolean): void {
        this.isCardConsumption = isCardConsumption;
        this.create();
    }
}